/**
 * Extracts a user-readable error message from an Angular HTTP error response.
 *
 * Angular's `HttpClient` wraps HTTP error bodies in `error.error`.
 * This utility drills into that structure and returns the first available
 * `message` string, falling back to the provided `fallback` string if none
 * is found.
 *
 * @param error   - Unknown value caught from a `catch` block (HttpErrorResponse or other)
 * @param fallback - String to return if no message can be extracted
 */
export function extractHttpErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'error' in error) {
    const httpError = error as { error?: { message?: string } };
    if (httpError.error?.message) return httpError.error.message;
  }
  return fallback;
}
